import { useContext } from 'react';
import { TimeZoneContext } from '../contexts/TimeZoneContext';

const useTimeZone = () => useContext(TimeZoneContext);

export default useTimeZone;
